import React, { useState, useEffect } from 'react';

const TAGLINES = {
  fr: [
    'Avant de signer, CheckCheck.',
    'Avant de payer, CheckCheck.',
    'Un nouveau client ? CheckCheck.',
    'Des travaux importants ? CheckCheck.',
    'Curieux de voir ce que disent les chiffres ? CheckCheck.',
  ],
  nl: [
    'Voor u tekent, CheckCheck.',
    'Voor u betaalt, CheckCheck.',
    'Een nieuwe klant? CheckCheck.',
    'Grote werken gepland? CheckCheck.',
    'Benieuwd wat de cijfers zeggen? CheckCheck.',
  ],
};

export const RotatingTagline = ({ lang = 'fr' }) => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const lines = TAGLINES[lang] || TAGLINES.fr;

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % lines.length);
        setVisible(true);
      }, 500);
    }, 6000);
    return () => clearInterval(interval);
  }, [lines.length]);

  return (
    <p
      className={`text-sm text-slate-400 text-center italic transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0'}`}
      data-testid="rotating-tagline"
    >
      {lines[index]}
    </p>
  );
};
